angular.module('ClinicApp').directive('afterRender', function() {
  return {
    restrict: 'A',
    scope: {
      afterRender: '=afterRender',
    },

    link: function($scope, element) {
      if (!$scope.afterRender) {
        throw new Error('You must provide a function to the after-render directive');
      }

      angular
        .getTestability(element)
        .whenStable(function() {
          $scope.afterRender();
        });
    },
  };
});
